import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { CategoryService } from 'src/api/services/category.service';
import { CategoryListResponseDataItem, ProductListResponseDataItem } from 'src/api/models';
import { ProductService } from 'src/api/services';
import { HttpClient } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { BreadcrumbsComponent } from '../bread-crumbs/bread-crumbs.component';

@Component({
  selector: 'app-catalog-main',
  templateUrl: './catalog-main.component.html',
  styleUrls: ['./catalog-main.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('1000ms', style({ opacity: 0 }))
      ])
    ]
    )
  ]
})
export class CatalogMainComponent implements OnInit {

  @Input() startCategoryId: number = null;
  dataCat: Array<CategoryListResponseDataItem>;

  showNext: boolean = true;
  showPrev: boolean = false;

  showLoader: boolean;
  currentCatTitle: string[];
  @ViewChild(BreadcrumbsComponent) breadcrumbsComponent!: BreadcrumbsComponent;

  constructor(
    public catService: CategoryService,
    public prodService: ProductService,
    public meta: Meta,
    public title: Title,
    public router: Router, public activatedRoute: ActivatedRoute, private appService: AppService) { }



  ngOnInit() {
    this.fill()
  }

  currentCatChanged(value: string[]) {
    this.currentCatTitle = value;
    this.setSEO();
  }
  setSEO() {
    if (this.currentCatTitle.length > 0) {
      const part = (this.currentCatTitle.length > 1) ? ' ' + $localize`:@@Catalog.By:by` + ' ' + this.currentCatTitle[0] : '';
      const headerMeta = $localize`:@@Catalog.Buy:Buy` + ' ' + this.currentCatTitle[this.currentCatTitle.length - 1] + part + '. ' + $localize`:@@Catalog.Worldwide:Worldwide delivery.`; //Импорт, доставка по России
      this.meta = this.appService.setSEO(this.meta, this.currentCatTitle.slice(-1)[0], headerMeta);
      this.title.setTitle(this.currentCatTitle[this.currentCatTitle.length - 1] + part);
    }
  }

  fill(id: number = null) {
    this.showLoader = true;
    if (id != null)
      this.startCategoryId = id
    const cat_params = {
      filters: { "parent_category": this.startCategoryId },
      "pagination[pageSize]": 1000
    }
    this.catService.getCategories(cat_params).subscribe(result => {
      this.dataCat = result.data;
      this.showLoader = false;
    },
      error => { },
      () => {
        this.showLoader = false;
      });
  }
}


